import { render } from "./ButhiGuideModal.vue?vue&type=template&id=f4ee5288&scoped=true"
import script from "./ButhiGuideModal.vue?vue&type=script&lang=js"
export * from "./ButhiGuideModal.vue?vue&type=script&lang=js"

import "./ButhiGuideModal.vue?vue&type=style&index=0&id=f4ee5288&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\wkphi\\Desktop\\Programming\\buthigame - Copy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4ee5288"]])

export default __exports__